export default __webpack_public_path__ + "static/media/shoe05.3fc07f97.jpg";